
// lib/strapi.ts
// ⚠️ Côté serveur → 127.0.0.1:1337 (accès direct à Strapi, pas de Nginx)
// ⚠️ Côté client  → https://enap.dz (via Nginx)

export const STRAPI_URL =
  typeof window === 'undefined'
    ? (process.env.STRAPI_URL || 'http://127.0.0.1:1337')
    : (process.env.NEXT_PUBLIC_STRAPI_URL || 'https://enap.dz');

export const STRAPI_TOKEN = process.env.STRAPI_TOKEN || '';